import { Divider, Gutter, Text, ZonedTime } from '@common/components';
import React, { ReactNode } from 'react';

export const ComplianceItemFilesListCustomHeader = ({
  complianceItemStateApprovedAt,
  formContent,
}: {
  complianceItemStateApprovedAt: string | null;
  formContent?: ReactNode;
}) => (
  <>
    <Gutter>
      Documents
      {complianceItemStateApprovedAt && (
        <Gutter direction="top">
          <Text size="sm" color="midnightRegular">
            Approved on{' '}
            <ZonedTime
              date={complianceItemStateApprovedAt}
              variant="long_format"
            />
          </Text>
        </Gutter>
      )}
    </Gutter>

    {formContent && (
      <>
        <Divider />
        <Gutter direction="top" size="md" />

        <Gutter direction="horizontal">{formContent}</Gutter>
      </>
    )}
  </>
);
